import type { HTMLAttributes, Ref } from "react";

import { cn } from "../../lib/utils";
import { useCardContext } from "./CardContext";
import { cardFooterVariants } from "./styles";

export interface CardFooterProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

/**
 * A compact action row. Children are pushed to opposite ends, so wrap each side in its own
 * element (e.g. two `Button.Group`s) for a leading and trailing cluster.
 */
export const CardFooter = ({ className, ref, ...props }: CardFooterProps) => {
  const { variant, padding } = useCardContext();

  return (
    <div
      ref={ref}
      data-slot="card-footer"
      className={cn(cardFooterVariants({ variant, padding }), className)}
      {...props}
    />
  );
};
